'use strict';

module.exports = document.createElement('div').style;



/*****************
 ** WEBPACK FOOTER
 ** ./~/domkit/builtinStyle.js
 ** module id = ./node_modules/domkit/builtinStyle.js
 ** module chunks = 0
 **/